import { GET } from "../../../module/services/fetch";
import { map } from "rxjs/operators";
import { entitlementSelectedItem } from "./request";

export const fetchEntitlementBAORequests = () =>
  GET("user/getBAOEntitlements").pipe(map((response: any) => response));

export const fetchEntitlementBeneficiaryListRequests = (
  payload: entitlementSelectedItem
) =>
  GET("users?entitlementId=" + payload.entitlement_id).pipe(
    map((response: any) => response)
  );

export const fetchBusinessRolerBeneficiaryListRequests = (
  payload: entitlementSelectedItem
) =>
  GET("users?businessRoleId=" + payload.entitlement_id).pipe(
    map((response: any) => response)
  );

export const fetchBrEntitlementsService = (brId: string) =>
  GET(`entitlements/businessRoleEnt?brId=${brId}`).pipe(
    map((response: any) => response)
  );
